import { Text } from '@mantine/core';
import { type ReactNode } from 'react';

interface Props {
  clamp?: number;
  children: ReactNode;
}

export const ClampedTextCell = (props: Props) => {
  const { children, clamp = 2 } = props;
  return <Text lineClamp={clamp}>{children}</Text>;
};
